import {useEffect,useState} from 'react'
//import {UserEditModalHeader} from './UserEditModalHeader'
//import {UserEditModalFormWrapper} from './UserEditModalFormWrapper'
import { ViewModalHeader } from './ViewModalHeader'
import axios from 'axios'
import { Card4 } from '../../../../../_metronic/partials/content/cards/Card4'
import { getPermisoId ,getPermisoIdGlobal, getpermisosDisponiblesGlobal} from '../../../ctr-r/CTXRegister/request/request'
import Swal from 'sweetalert2'
import { getpermisosDisponibles } from '../../../ctr-r/CTXRegister/request/request'
import { useAuth } from '../../../auth'
import { useAppSelector } from '../../../../../redux/hooks'
import { getram, getramtenant } from '../request/request'
const API_URL = process.env.REACT_APP_API_URL


type Rol=
  {
  name:string
  description:string
  id:string
  Permissions:x[]

 

  }
type x=
{
  id: string
  name:string
  description:string
}


type Ram={
  type:any
  vcpu:any
  ram:any
}

const EntitlementForti = ( props:any ) => {
  /*********************************Constantes**************************************** */
  const tenant= useAppSelector(state =>state.TenantSlice.id)

  const{currentUser}= useAuth()
  const[PermisosDisp, setPermisoDisp]=useState<x[]>([])
  const [selectedItems, setSelectedItems] = useState<number[]>([]);


  const [IdPermiso,setIdPermiso]= useState<Rol>({
    name:'',
    description:'',
    id:'',
    Permissions:[]
   
  })


  // eslint-disable-next-line
  const [loading, setLoading] = useState(false)

  ////
  const [Nombre,setNombre] = useState('');
  const [Memory,setMemory] = useState(0);
  const [VCPU,setVCPU] = useState(0);
  const [entitlement,setentitlement] = useState('');





  
  

  /************************************llamadas a la API ********************************************** */

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  useEffect(() => {
    //colocar llamada al ep de ticket for id 
    const fetchData = async () => {
      try {
        if( props.id !== "" ){
          if (currentUser?.ListPermiso?.includes('Roles.Update')){
            if(tenant===0){
              const UserResponse = await getPermisoId(props.id);
              setIdPermiso(UserResponse.data);
              const permisosupdate= []
              for (const a of UserResponse.data.Permissions){
                permisosupdate.push(a.id)
              }
              setSelectedItems(permisosupdate)
            }
            else if(tenant!==0){
              const UserResponse = await getPermisoIdGlobal(props.id,tenant);
              setIdPermiso(UserResponse.data);
              const permisosupdate= []
              for (const a of UserResponse.data.Permissions){
                permisosupdate.push(a.id)
              }
              setSelectedItems(permisosupdate)
            }
          }
      }
      } catch (error) {
        console.error('Error al obtener los permisos', error);
      }
       };
  
      fetchData();
  }, [props.id])


  useEffect(() => {
    //se llama al ep de permisos 
    const fetchData = async () => {
      try {
        if(tenant===0){
          const permisos = await getpermisosDisponibles();
          setPermisoDisp(permisos.data)
        }
        else{
          const permisos = await getpermisosDisponiblesGlobal(tenant);
          setPermisoDisp(permisos.data)
        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
       };
  
      fetchData();
  }, [props.id])


  


  /************************************************************************* */
  

    //const navigate = useNavigate();

    const handleSubmit =async (e:any) => {
    e.preventDefault();

    try{
      const permision= []
      for (const y of selectedItems){
        permision.push({id:y})
      }
      
      
      
      if(props.id !==null){
        const actualizar={
          name:IdPermiso.name,
          description:IdPermiso.description,
          id:IdPermiso.id,
          Permission: permision
        }
       if (tenant===0){ 
          await axios.put(API_URL+'/v1/rol/'+props.id, actualizar)
          .then(res=>{ Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Your Role has Update',
            showConfirmButton: false,
            timer: 1500
          })
          window.location.reload();
        });
        }
        else{
          await axios.put(API_URL+'/v1/rol/'+props.id+'?tenantId='+tenant, actualizar)
          .then(res=>{ Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Your Role has Update',
            showConfirmButton: false,
            timer: 1500
          })
          window.location.reload();
        });
        }
      
      }

      else{
        const body ={
          name:Nombre,
          description:VCPU,
          Permission:permision,
        }
        if(tenant===0){
        await axios.post(API_URL+'/v1/rol/', body)
        .then(res=>{ Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Your Role has created',
          showConfirmButton: false,
          timer: 1500
        
        })
        window.location.reload();

      });
      }
      else{
        await axios.post(API_URL+'/v1/rol/?tenantId='+tenant, body)
        .then(res=>{ Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Your Role has created',
          showConfirmButton: false,
          timer: 1500
        })
        window.location.reload();
      });
      }
      //navigate('/support/SeeRequest')
    }
  }
    catch(error:any){
      console.log(error)

    }

    
   }

  

  ///////////////////////////////////////////////

  


  
  

    const handleCheckboxChange = (event:any) => {
        const { value, checked } = event.target;
        
        if (checked) {
            setSelectedItems((prevSelectedItems:Array<number>) => [...prevSelectedItems, Number(value)]);
        } else {
            setSelectedItems((prevSelectedItems:Array<number>) =>
                prevSelectedItems.filter((item) => item !== Number(value))
            );
        }
    };

   




/**********************cosas nuevas**********************/

const [DataRam,setRam]= useState<Ram[]>([])
const [type,setType]=useState('')


useEffect( () => {
     if(tenant ===0){
        getram(VCPU).then(response=>{
          if (response.data.length > 0) {
            setRam(response.data)}
            else{
              setRam([{type:'No Data',vcpu:'',ram:''}])
            }
        })
     }
     else if(tenant !==0){
        getramtenant(VCPU,tenant).then(response=>{
          if (response.data.length > 0) {
            setRam(response.data)}
          else{
            setRam([{type:'No Data',vcpu:'',ram:''}])
          }
        })
     }
    }
    , [VCPU,tenant])

  
  let GBRam=''

  for (const x of DataRam){
      if(type=== x.type){
        GBRam = x.ram
      }
  }

   

  return (
    
    <>
    {props.id !==null &&
    <div>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <ViewModalHeader setID={props.setID} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
            <form className='form w-100' id='kt_login_signin_form' onSubmit={handleSubmit} >
                                {/* begin::Heading */}
                                <div className='text-center mb-5'>
                                <h1 className='text-marni f-titulo fw-bolder mb-3'>Edit Device</h1>
                                </div>
                                {/* begin::Heading */}
                        
                                
                               
                                {/* Campos solicitud */}
                                <div>
                                   <label className='form-label fw-bolder text-marino f-parrafo fs-6 mb-0' htmlFor="name">Name</label>
                                   <input type="text" name='name' value={IdPermiso.name}className='form-control border-marino' 
                                   onChange={(e:any) => setIdPermiso({...IdPermiso,name: e.target.value})}/>
                                </div>
                                <br />
                                <div className='row'>
                                    <div className='col'>
                                      <label className='form-label fw-bolder text-marino f-parrafo fs-6 mb-0' htmlFor="apellido">VCPU</label>
                                      <input type="text" name='apellido' value={IdPermiso.description}className='form-control border-marino' 
                                      onChange={(e:any) => setIdPermiso({...IdPermiso,description: e.target.value})}/>
                                    </div>
                                    <div className='col'>
                                      <label className='form-label fw-bolder text-marino f-parrafo fs-6 mb-0' htmlFor="apellido">Memory</label>
                                      <input type="text" name='apellido' value={IdPermiso.description}className='form-control border-marino' 
                                      onChange={(e:any) => setIdPermiso({...IdPermiso,description: e.target.value})}/>
                                    </div>
                                </div>

                                <br />
                               <div>
                               <label className='form-label fw-bolder text-marino f-parrafo fs-6 mb-0 required form-label'>Entitlement</label>
                                    <select 
                                     required
                                     id='Prioridad'
                                     value={entitlement}
                                     onChange={(e) => setentitlement(e.target.value)}

                                    className="form-select form-select-solid  border-marino " aria-label="Select example">
                                      <option selected hidden>Select</option>
                                      <option className="text-success" value="1">Low</option>
                                      <option className="text-warning" value="2">Medium</option>
                                      <option className="text-danger" value="3">High</option>
                                      <option className="text-light-danger bg-danger" value="4">Urgent</option>
                                    </select>
                                </div>
                                
                              
                                <br />
                                 {/* begin::Action */}
                                 <div className='d-grid mb-10'>
                                  
                                  <button
                                    type='submit'
                                    id='kt_sign_in_submit'
                                    className='btn btn-primary'
                             
                                    
                                  >
                                    {!loading && <span className='indicator-label'>Save</span>}
                                    {loading && (
                                      <span className='indicator-progress' style={{display: 'block'}}>
                                       Please wait...
                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                      </span>
                                    )}
                                  </button>
                                </div>
                                {/* end::Action */}

                                
                            </form>
                            
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
      </div>
      }


      {props.id === null &&
      <div>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <ViewModalHeader setID={props.setID} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
            <form className='form w-100' id='kt_login_signin_form' onSubmit={handleSubmit} >
                                {/* begin::Heading */}
                                <div className='text-center mb-5'>
                                <h1 className='text-marni f-titulo fw-bolder mb-3'>Create Entitlement</h1>
                                </div>
                                {/* begin::Heading */}
                        
                                {/* begin::Login options */}

                               
                                {/* Campos solicitud */}
                                <div>
                                   <label className='form-label fw-bolder text-marino f-parrafo fs-6 mb-0 required' htmlFor="name">Number of CPU's</label>
                                   <input type="number" 
                                      name='VCPU' 
                                      className='form-control border-marino' 
                                      id='VCPU'
                                      value={VCPU}
                                      onChange={(e) => {
                                        const inputValue = parseFloat(e.target.value);
                                        if (!isNaN(inputValue) && inputValue >= 0) {
                                          // Actualizar el estado solo si es un número no negativo
                                          setVCPU(inputValue);
                                        }
                                        // Puedes agregar un mensaje de error o manejo adicional aquí si lo necesitas
                                      }}
                                      />
                                </div>
                                <br />
                                <div className='row'>
                                   <div className='col'>
                                      <label className='form-label fw-bolder text-marino f-parrafo fs-6 mb-0 required' htmlFor="descripcion">Instance Type</label>
                                        <select 
                                        required
                                        id='Prioridad'
                                        value={type}
                                        onChange={(e) => setType(e.target.value)}
                                        className="form-select form-select-solid  border-marino " aria-label="Select example">
                                          <option selected hidden>Select</option>
                                          {DataRam.map((type:any,i:any)=>(
                                              <option key={i} className="text-success" value={type.type}>{type.type}</option>
                                          ))}
                                        </select>
                                   </div>

                                   <div className='col'>
                                   <label className='form-label fw-bolder text-marino f-parrafo fs-6 mb-0' htmlFor="descripcion">Memory</label>
                                      <input type="text" 
                                      name='Memory' 
                                      className='form-control border-marino disabled' 
                                      id='Memory'
                                      value={GBRam}
                                
                                      />                                   
                                   </div>
                                </div>                              
                               <br />
                               <div>
                               <label className='form-label fw-bolder text-marino f-parrafo fs-6 mb-0 required form-label'>Entitlement</label>
                                    <select 
                                     required
                                     id='Prioridad'
                                     value={entitlement}
                                     onChange={(e) => setentitlement(e.target.value)}

                                    className="form-select form-select-solid  border-marino " aria-label="Select example">
                                      <option selected hidden>Select</option>
                                      <option className="text-success" value="1">Low</option>
                                      <option className="text-warning" value="2">Medium</option>
                                      <option className="text-danger" value="3">High</option>
                                      <option className="text-light-danger bg-danger" value="4">Urgent</option>
                                    </select>
                                </div>
                                <br />
                                      {/* end::Label */}
                                    {/* end::Radio */}

                                {/* begin::Action */}
                                <div className='d-grid mb-10'>
                                  
                                  <button
                                    type='submit'
                                    id='kt_sign_in_submit'
                                    className='btn btn-primary'
                             
                                    
                                  >
                                    {!loading && <span className='indicator-label'>Save</span>}
                                    {loading && (
                                      <span className='indicator-progress' style={{display: 'block'}}>
                                       Please wait...
                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                      </span>
                                    )}
                                  </button>
                                </div>
                                {/* end::Action */}

                            </form>
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
      </div>
      }   
      
    </>
  )
}
export {EntitlementForti}